export default __webpack_public_path__ + "static/media/Pot1.10939ebc.svg";